export const FONT_SIZE_BASIC = '14px';

export const FONT_SIZE_012 = '12px';

export const FONT_SIZE_014 = '14px';

export const FONT_SIZE_016 = '16px';

export const FONT_SIZE_020 = '20px';

export const FONT_SIZE_024 = '24px';

export const FONT_SIZE_030 = '30px';

export const FONT_SIZE_036 = '36px';

export const FONT_SIZE_048 = '48px';

export const FONT_SIZE_060 = '60px';

const BasicFontSize = {
    FONT_SIZE_BASIC,
    FONT_SIZE_012,
    FONT_SIZE_014,
    FONT_SIZE_016,
    FONT_SIZE_020,
    FONT_SIZE_024,
    FONT_SIZE_030,
    FONT_SIZE_036,
    FONT_SIZE_048,
    FONT_SIZE_060,
};

export default BasicFontSize;
